import { render, staticRenderFns } from "./TrackerDetails.vue?vue&type=template&id=008335fa&scoped=true"
import script from "./TrackerDetails.vue?vue&type=script&lang=js"
export * from "./TrackerDetails.vue?vue&type=script&lang=js"
import style0 from "./TrackerDetails.vue?vue&type=style&index=0&id=008335fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "008335fa",
  null
  
)

export default component.exports